import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function NotFound() {
    useEffect(() => {
        // Tell crawlers this is a real 404, not a soft 200
        document.title = "Page not found — Eat + Drink Consulting";
        const m = document.querySelector('meta[name="robots"]');
        if (m) m.setAttribute("content", "noindex, follow");
    }, []);

    return (
        <main
            data-testid="not-found-page"
            className="min-h-screen bg-brand-cream text-brand-dark flex items-center"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-32 w-full">
                <div className="grid grid-cols-12 gap-10 items-end">
                    <div className="col-span-12 md:col-span-7">
                        <div className="flex items-center gap-4 mb-6">
                            <span className="h-px w-12 bg-brand-orange" />
                            <span className="text-xs uppercase tracking-[0.3em] text-brand-orange font-medium">
                                Error · 404
                            </span>
                        </div>
                        <h1 className="font-serif text-[18vw] sm:text-[14vw] md:text-[10vw] leading-[0.9] tracking-tighter text-brand-dark mb-6">
                            Off the
                            <br />
                            <span className="italic font-light text-brand-orange">menu.</span>
                        </h1>
                        <p className="text-lg md:text-xl text-brand-muted font-light leading-relaxed max-w-xl mb-10">
                            The page you're looking for isn't on the menu — or it's been re-plated.
                            Head back to the homepage and let's find what you came for.
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4">
                            <Link
                                to="/"
                                data-testid="not-found-home-link"
                                className="inline-flex items-center gap-3 bg-brand-orange text-brand-cream px-8 py-4 text-xs uppercase tracking-[0.25em] hover:bg-brand-orange-hover transition-colors group"
                            >
                                Back to homepage
                                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                            </Link>
                            <Link
                                to="/#contact"
                                data-testid="not-found-contact-link"
                                className="inline-flex items-center gap-3 border border-brand-dark text-brand-dark px-8 py-4 text-xs uppercase tracking-[0.25em] hover:bg-brand-dark hover:text-brand-cream transition-colors"
                            >
                                Get in touch
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}
